import { Notify } from '@flexisaf/flexibull2';
import { StudentBillRestControllerService } from 'generated';
import { put, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';
import { addItemToInvoiceFail, addItemToInvoiceSuccess } from '../actions';
import invoiceActionTypes from '../types';

export function* addItem({ payload }) {
  const { student_id, data, callback } = payload;
  try {
    const response = yield apiWrapper(() =>
      StudentBillRestControllerService.createInvoiceItemUsingPost({
        request: { items: data },
        studentId: student_id,
      }),
    );
    yield put(addItemToInvoiceSuccess(response));
    callback();
    Notify('Item added successfully', { position: 'top-right' });
  } catch (error) {
    yield put(addItemToInvoiceFail(error?.message));
    const err = handleError(error);
  }
}

export function* onAddItemToInvoiceStart() {
  yield takeLatest(invoiceActionTypes.ADD_ITEM_TO_INVOICE_START, addItem);
}
